import L from "leaflet"

export interface ParsedShape {
  id: string
  positions: { lat: number; lon: number }[]
}

function getString(dataView: DataView, offset: number, length: number) {
  let string = ""
  for (let i = 0; i < length; i++) {
    const char = dataView.getUint8(offset + i)
    if (char === 0) break
    string += String.fromCharCode(char)
  }
  return string
}

export function parseShapeFile(file: ArrayBuffer): ParsedShape[] {
  const view = new DataView(file)
  const magic = getString(view, 0, 4)
  if (magic !== "SHAP") throw new Error("shape file not valid!")

  const lookupOffset = view.getUint32(4, true) + 24
  const edges = {
    top: view.getFloat32(8, true),
    bottom: view.getFloat32(12, true),
    left: view.getFloat32(16, true),
    right: view.getFloat32(20, true),
  }

  const lookupTableSize = view.getUint16(lookupOffset, true)
  const lookupTable: { id: string; offset: number; count: number }[] = []
  let fileOffset = lookupOffset + 2

  for (let index = 0; index < lookupTableSize; index++) {
    const idLen = view.getUint8(fileOffset)
    const id = getString(view, fileOffset + 1, idLen)
    const offset = view.getUint32(fileOffset + idLen + 1, true) + 0x18
    const count = view.getUint16(fileOffset + idLen + 5, true)
    lookupTable.push({ id, offset, count })
    fileOffset += idLen + 7
  }

  const toLatLon = (lat: number, lon: number) => ({
    lat: (lat / 65535) * (edges.bottom - edges.top) + edges.top,
    lon: (lon / 65535) * (edges.right - edges.left) + edges.left,
  })

  return lookupTable.map((entry) => {
    const positions: { lat: number; lon: number }[] = []
    for (let index = 0; index < entry.count; index++) {
      const lat = view.getUint16(entry.offset + index * 4, true)
      const lon = view.getUint16(entry.offset + index * 4 + 2, true)
      positions.push(toLatLon(lat, lon))
    }
    return { id: entry.id, positions }
  })
}

export function polylineLatLngs(shape: ParsedShape): L.LatLngExpression[] {
  return shape.positions.map((p) => [p.lat, p.lon])
}
